import { createFilledIcon } from "../createIcon";

export const ClockFilledIcon = createFilledIcon(
  <>
    <path d="M12.5 21.6a9.6 9.6 0 1 0 0-19.2 9.6 9.6 0 0 0 0 19.2Zm1-14.1a1 1 0 1 0-2 0V12a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13.5 11.586V7.5Z" />
  </>,
  "ClockFilledIcon"
);
